import { apiService } from "@/api";


/**
 * 6. POST /customer-level/program/{program_id}
 */
export async function createCustomerLevelProgram(programId: string, payload: object) {
  const response = await apiService({
    url: `/customer-level/program/${programId}`,
    method: "post",
    protectedRoute: true,
    requestData: payload,
  });
  return response;
}

export async function getCustomerLevel(customerLevelId: string) {
  const response = await apiService({
    url: `/customer-level/${customerLevelId}`,
    method: "get",
    protectedRoute: true,
  });
  return response;
}

export async function updateCustomerLevelProgram(customerLevelId: string, payload: object) {
  const response = await apiService({
    url: `/customer-level/${customerLevelId}`,
    method: "put", // or "patch", depending on your API design
    protectedRoute: true,
    requestData: payload,
  });
  return response;
}

/**
 * 7. GET /customer-level/program/{program_id}
 */
export async function getCustomerLevelProgram(programId: string) {
  const response = await apiService({
    url: `/customer-level/program/${programId}`,
    method: "get",
    protectedRoute: true,
  });
  return response;
}

// api/customerLevel.ts
export async function deleteCustomerLevel(customerLevelId: string) {
  const response = await apiService({
    url: `/customer-level/${customerLevelId}`,
    method: "delete",
    protectedRoute: true,
  });
  return response;
}

/**
 * Update a customer level
 * PUT /customer-level/program/{program_id}/{customer_level_id}
 */
export async function updateCustomerLevel(programId: string, customerLevelId: string, payload: object) {
  const response = await apiService({
    url: `/customer-level/program/${programId}/${customerLevelId}`,
    method: "put",
    protectedRoute: true,
    requestData: payload,
  });
  return response;
}